import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import { Category, getCategoryById } from "@insite/client-framework/Services/CategoryService";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { css } from "styled-components";

interface Props extends WidgetProps, HasCategoryContext {}

export interface ContentBlockStyles {
    wrapper?: InjectableCss;
}

export const contentBlockStyles: ContentBlockStyles = {
    wrapper: {
        css: css`
            width: 100%;
            max-width: 100%;
            margin-bottom: 40px;
        `,
    },
};

const styles = contentBlockStyles;

const ProductListContentBlock = ({ category }: Props) => {
    const [renderData, setRenderData] = React.useState<string | undefined>(undefined);

    React.useEffect(() => {
        setRenderData(undefined);

        if (!category) {
            return;
        }

        if (category?.properties.categoryContent2) {
            setRenderData(category?.properties.categoryContent2);
        } else if(category?.id) {
            const [extractedId] = category.id.split(":");
            // Ensure extractedId exists
            // OOTB addBrandToId make
            // category.id = `${category.id}:${brandId}`;
            // leading to api error
            if (!extractedId) {
                return;
            }
            getNewCategoryData(extractedId);
        }
    }, [category]);

    const getNewCategoryData = async (categoryId: string | undefined) => {
        if (categoryId) {
            const categoryData = await getCategoryById({ id: categoryId });
            if (categoryData.properties.categoryContent2) {
                setRenderData(categoryData.properties.categoryContent2);
            }
        }
    };

    if (renderData) {
        return (
            <StyledWrapper {...styles.wrapper}>
                <Typography>{parse(renderData, parserOptions)}</Typography>
            </StyledWrapper>
        );
    }

    return null;
};

const widgetModule: WidgetModule = {
    component: withCategory(ProductListContentBlock),
    definition: {
        allowedContexts: ["ProductListPage", "CategoryDetailsPage"],
        group: "Product List",
        displayName: "Inferior Content Block",
    },
};

export default widgetModule;
